import '../index.scss';
import React, { Component } from 'react';
import { cloneDeep, isEqual } from 'lodash';
import Checkbox from '../../shared/components/checkbox';
import PropTypes from 'prop-types';


class ClaimAuditMessages extends Component {

    state = {
        claimAuditMessage: [],
    };

    items = '';

    componentWillMount = () => {

        this.updateState( 'claimAuditMessage', this.props.auditMessages );

    }

    updateState = ( name, val ) => {

        this.setState( {
            [name]: val,
        } );

    }

    onEditBtnClicked = () => {

        this.props.enableEditCmp( 'Audit Messages' );

    }

    onSaveBtnClicked = () => {

        if ( this.props.auditMessages !== this.state.auditMessage ) {

            this.props.updateClaim( 'auditMessages', this.state.claimAuditMessage );

        } else this.onCancelBtnClicked();

    }

    handleChange = props => () => {

        const updatedData = cloneDeep( this.state.claimAuditMessage );

        updatedData.forEach( ( element, index ) => {

            if ( element.auditCode === props.auditCode ) {

                updatedData[index].skip = !props.skip;

            }

        } );

        this.updateState( 'claimAuditMessage', updatedData );

    }

    onCancelBtnClicked = () => {

        if ( this.props.enableEditCmp( 'Audit Messages' ) ) {

            this.setState( {
                claimAuditMessage: this.props.auditMessages,
            } );

        }

    }


    updatedMessages = messages => {

        this.updateState( 'claimAuditMessage', messages.target.value );

    };

    componentWillReceiveProps = nextProps => {

        if ( !isEqual( nextProps.auditMessages, this.props.auditMessages ) ) {

            this.setState( {
                claimAuditMessage: nextProps.auditMessages,
            } );
            this.items = '';

        }

    }

    render () {

        this.items = '';
        this.items = ( this.state.claimAuditMessage ).map( item => (
            <div className="body">
                <div className="cell">{item.auditCode}</div>
                <div className="cell">{item.auditMessage}</div>
                <div className="cell">{
                    <Checkbox
                        label=""
                        value={item.auditCode}
                        handleCheckboxChange={this.handleChange( item )}
                        id={`skip${item.auditCode}`}
                        isChecked={item.skip}
                        isDisabled={!this.props.isEdit}
                    />
                }
                </div>
            </div>
        ) );
        return (
            <div className="audit-info">
                <section className="audit-messages">
                    <header>
                        <i title="Edit" className={`fa fa-edit ${!this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onEditBtnClicked} />
                        <i className={`fa fa-save ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onSaveBtnClicked} />
                        <i className={`fa fa-remove ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onCancelBtnClicked} />
                    </header>
                    <div className="tbl">
                        <div className="head">
                            <div className="cell">Audit Code </div>
                            <div className="cell">Audit Message </div>
                            <div className="cell">Skip</div>
                        </div>
                        {this.items}
                    </div>

                </section>
            </div>
        );

    }

}
ClaimAuditMessages.displayName = 'Claim Audit Messages';
ClaimAuditMessages.propTypes = {
    auditMessages: PropTypes.object.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    updateClaim: PropTypes.func.isRequired,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
};

export default ClaimAuditMessages;
